<template>
	<div class="statisticalAnalysis disBetween">
		<div class="statisticalLeft">
			<div class="itemTitleBox disStart">
				<div class="disStart">
					<span class="title">今日统计</span>
				</div>
				<!-- <div class="myinputBox">
					<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称">
					</el-input>
				</div>
				<div class="myinputBox" v-if="!($serviceProviderId)">
					<el-select clearable v-model="searchObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
						<el-option v-for="(item,inx) in serviceList" :key="inx" :label="item.serviceProviderName"
							:value="item.serviceProviderId"></el-option>
					</el-select>
				</div>
				<el-button type="success" @click="toSearch">查询</el-button> -->
			</div>
			<div class="listBox">
				<div class="contentBox scrollContBox">
					<ul ref="scrollview" class="scrollUl">
						<li class="scrollLi disCenter" :class="{active:active==1}" @click="activeClick(1)">
							<div class="imgBox img1"></div>
							<div class="itemBox ">
								<div class="valueBox">
									充值金额
								</div>
								<div class="valueBox">
									<span>{{recordObj.coinAmount}}</span>元
								</div>
							</div>
						</li>
						<li class="scrollLi disCenter" :class="{active:active==2}" @click="activeClick(2)">
							<div class="imgBox img2"></div>
							<div class="itemBox ">
								<div class="valueBox">
									赠送金额
								</div>
								<div class="valueBox">
									<span>{{recordObj.extraCoinAmount}}</span>元
								</div>
							</div>
						</li>
						<li class="scrollLi disCenter" :class="{active:active==3}" @click="activeClick(3)">
							<div class="imgBox img3"></div>
							<div class="itemBox ">
								<div class="valueBox">
									提现金额
								</div>
								<div class="valueBox">
									<span>{{recordObj.refundAmount}}</span>元
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>

	</div>
</template>

<script type="text/javascript">
	export default {
		name: "statisticalAnalysis",
		data() {
			return {
				recordObj: {
					accountBalance:"",
					accountExtraBalance:"",
					totalExtraCoinAmount:"",
					totalRechargeAmount:"",
					totalRefundAmount:"",
				},
				searchObj:{
					communityName:"",
					serviceProviderId:"",
				},
				serviceList: [],
				active: 1,
				loading: false,
				echartObj: {
					title: "充电次数",
					unit: "次"
				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
				this.selectParamConfigByCode()
			})
		},
		methods: {
			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "serviceList", res.obj || [])
					}
				})
			},
			toSearch(){
				this.getData()
			},
			activeClick(){},
			getData() {
				this.$api.todayStatisticalAnalysis(this.searchObj).then((res)=>{
					if(res.returnCode==200){
						this.$set(this,"recordObj",res.obj)
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./statisticalAnalysis.scss";
</style>
